import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { FormService } from '../../../form/form.service';

@Component({
    selector: 'app-value-input',
    template: `
        <form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()">
            <section class="simple__input-wrapper">
                <app-input
                    controlName="value"
                    [parentForm]="form"
                    [label]="'filterpage.exchange_car_facet____input_placeholder' | translate"
                ></app-input>
            </section>
        </form>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValueInputComponent implements OnChanges {
    @Input() currentValue?: number | null;
    @Output() handleChange = new EventEmitter<string>();

    form?: UntypedFormGroup;
    constructor(private fb: UntypedFormBuilder) {
        this.form = this.fb.group(
            {
                value: ['', { validators: [Validators.pattern('^[0-9]*$'), Validators.maxLength(7)] }], // whole numbers only
            },
            {
                updateOn: 'change',
            }
        );
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.currentValue) {
            this.form?.controls['value'].setValue(this.currentValue || undefined);
        }
    }

    onSubmit() {
        if (this.form?.invalid || this.form?.disabled) {
            FormService.markControlsAsTouched(this.form);
            return;
        }
        const { value }: { [key: string]: string } = this.form?.value;
        this.handleChange.emit(value);
    }
}
